import { useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import GrTextField from "src/design-system/components/GrTextField";
import GrButton from "src/design-system/components/GrButton";
import { GrPasswordToggle } from "src/design-system/components/GrAuthLayout";
import { gr } from "src/design-system/tokens";

// Labels always above the fields: a browser that autofills on load does not tell the page until the
// field is clicked, so a floating label would sit on top of the saved email / password.
const LABEL_ABOVE = { shrink: true };

export default function NewPasswordForm({
  onhandleNewPasswordSubmit,
  setIsLoading,
  isLoading,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };
  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (!newPassword) {
      return;
    }
    if (!confirmPassword) {
      return;
    }
    if (newPassword !== confirmPassword) {
      enqueueSnackbar("Password and Confirm Password does not match", {
        variant: "error",
      });
      return;
    }
    onhandleNewPasswordSubmit(newPassword, confirmPassword);
  };

  // One toggle state for both fields, as before.
  const toggle = {
    endAdornment: (
      <InputAdornment position="end">
        <GrPasswordToggle shown={showPassword} onToggle={handleShowPassword} />
      </InputAdornment>
    ),
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: gr.space[4] }}>
        <GrTextField
          InputLabelProps={LABEL_ABOVE}
          autoComplete="current-password"
          type={showPassword ? "text" : "password"}
          label="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          InputProps={toggle}
        />
        <GrTextField
          InputLabelProps={LABEL_ABOVE}
          autoComplete="current-password"
          type={showPassword ? "text" : "password"}
          label="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          InputProps={toggle}
        />
      </Box>
      {/* The button only changes its text while sending (as before), it is not disabled. */}
      <GrButton type="submit" size="lg" fullWidth sx={{ mt: gr.space[6] }}>
        {isLoading ? "Updateing..." : "Update"}
      </GrButton>
    </form>
  );
}

NewPasswordForm.propTypes = {
  onhandleNewPasswordSubmit: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
